import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = { class: "w-80 desktop:w-160" };
const _hoisted_3 = { class: "flex-1" };
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = ["innerHTML"];
import clsx from 'clsx';
import { reactive, computed } from 'vue';
import { payToOnTest } from '@/user/helpers/payment.helper';
import { I18nInfo } from '@/user/models/i18n-info';
import CertificationApplyForm from '@/user/models/certification/certification-apply-form';
import { MonthlyExamInfo } from '@/user/models/certification/monthly-exam';
import { navigateTo, getCloudIdOrigin, routeToUrl } from '@/user/homepage-integration';
import store from '@/user/store';
import { BoxInput, Checkbox, FilledButton, Modal, ModalFooter, OutlinedButton, TextButton, } from '@/user/components/common';
import moment from 'moment';
import { useRouter } from 'vue-router';
const DATE_FORMAT = 'YYYY.MM.DD HH:mm';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CertificationApplyModal',
    props: {
        modelValue: { type: Boolean },
        exam: {},
        applySuccessCallback: { type: Function }
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const router = useRouter();
        const t_common = new I18nInfo('common');
        const t = new I18nInfo('certification.testApply.modal');
        const props = __props;
        const emit = __emit;
        const isOpen = computed({
            get: () => {
                return props.modelValue;
            },
            set: (value) => {
                emit('update:modelValue', value);
                if (!value) {
                    form.clearForm();
                }
            },
        });
        const styles = {
            wrapper: 'space-y-40',
            titleDesc: clsx('block text-title-2 py-0', 'desktop:py-4'),
            note: clsx('text-body-5 text-gray-800 mt-16', 'desktop:mt-0 desktop:py-4'),
            tableCover: clsx('w-full border-1 border-gray-250 rounded-12 overflow-hidden mt-16', 'desktop:mt-8'),
            table: 'w-full [&>tbody>tr:first-child>td]:border-t-0 [&>tbody>tr:first-child>th]:border-t-0',
            th: clsx('w-110 px-16 py-16 text-m-body-1 bg-gray-150 text-left border-gray-250 border-t-1', ' desktop:w-168 desktop:px-23 desktop:text-body-3'),
            td: clsx('px-15 py-17 border-gray-200 border-t-1 text-body-5', ' desktop:px-24 desktop:text-body-4'),
            inputTd: clsx('py-6 px-16 border-gray-200 border-t-1', ' desktop:py-8'),
            inputTd2: clsx('flex items-start gap-8', 'desktop:gap-10'),
            required: 'text-body-3 text-red-700',
            checkboxGroup: clsx('flex flex-col gap-8 py-20 border-t-1 border-gray-250', ' desktop:gap-0'),
            checkboxItem: 'flex items-center justify-between py-4',
            errorMsg: 'c-inp-error-message text-body-6 mt-4 text-red-700',
        };
        const memberInfo = reactive(store.getters['SecurityStore/userInfo']);
        const form = reactive(new CertificationApplyForm(memberInfo, props.exam.id, props.exam.amount, props.exam.level));
        async function onPayClick(e) {
            e.preventDefault();
            const isValid = await form.validateForSubmit();
            if (isValid) {
                const popup = window.open('about:blank', 'payWindow', 'width=680,height=800');
                // 팝업이 차단되었는지 확인
                if (!popup || popup.closed || typeof popup.closed === 'undefined') {
                    store.dispatch('AlertStore/showAlertModal', {
                        message: '팝업이 차단되었습니다. 팝업 차단을 해제해주세요.',
                    });
                    return;
                }
                try {
                    await store.commit(`LoaderStore/pending`);
                    const paidData = await form.submit();
                    if (paidData.paymentToken) {
                        const successCallback = () => {
                            props.applySuccessCallback({
                                totalAmount: paidData.paymentData.totalAmount,
                                discountCode: paidData.paymentData.discountCode,
                            });
                        };
                        const pgData = {
                            payAccessToken: paidData.paymentToken,
                            successCallback,
                            closeCallback: () => store.commit(`LoaderStore/done`),
                            popup,
                        };
                        payToOnTest(pgData);
                    }
                    else {
                        popup.close();
                    }
                }
                catch (error) {
                    popup.close();
                    const errorMessage = error?.response?.data?.message;
                    store.dispatch('AlertStore/showAlertModal', {
                        message: errorMessage,
                    });
                }
            }
        }
        async function handleAgreementDetail() {
            const resolvedRoute = router.resolve({
                name: 'terms-view',
                params: { id: 'privacy-member-exam' },
            });
            const url = await routeToUrl(resolvedRoute, true);
            window.open(url, '_blank');
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Modal), {
                modelValue: isOpen.value,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((isOpen).value = $event)),
                size: "large",
                title: __props.exam.title,
                "vertical-align": "mobileTop"
            }, {
                content: _withCtx(() => [
                    _createElementVNode("div", {
                        class: _normalizeClass(styles.wrapper)
                    }, [
                        _createElementVNode("div", null, [
                            _createElementVNode("strong", {
                                class: _normalizeClass(styles.titleDesc)
                            }, _toDisplayString(_unref(t).translate('formTitle')), 3),
                            _createElementVNode("div", {
                                class: _normalizeClass(styles.tableCover)
                            }, [
                                _createElementVNode("table", {
                                    class: _normalizeClass(styles.table)
                                }, [
                                    _createElementVNode("tbody", null, [
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", {
                                                class: _normalizeClass(styles.th)
                                            }, _toDisplayString(_unref(t).translate('testName')), 3),
                                            _createElementVNode("td", {
                                                class: _normalizeClass(styles.td)
                                            }, _toDisplayString(__props.exam.title), 3)
                                        ]),
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", {
                                                class: _normalizeClass(styles.th)
                                            }, _toDisplayString(_unref(t).translate('testDate')), 3),
                                            _createElementVNode("td", {
                                                class: _normalizeClass(styles.td)
                                            }, _toDisplayString(_unref(moment)(__props.exam.startAt).format(DATE_FORMAT)), 3)
                                        ]),
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", {
                                                class: _normalizeClass(styles.th)
                                            }, _toDisplayString(_unref(t).translate('testTime')), 3),
                                            _createElementVNode("td", {
                                                class: _normalizeClass(styles.td)
                                            }, _toDisplayString(__props.exam.examTime) + _toDisplayString(_unref(t).translate('timeUnit')), 3)
                                        ]),
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", {
                                                class: _normalizeClass(styles.th)
                                            }, _toDisplayString(_unref(t).translate('testMethod')), 3),
                                            _createElementVNode("td", {
                                                class: _normalizeClass(styles.td)
                                            }, _toDisplayString(_unref(t).translate(`testMethodValue.${__props.exam.method}`)), 3)
                                        ]),
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", {
                                                class: _normalizeClass(styles.th)
                                            }, _toDisplayString(_unref(t).translate('testAmount')), 3),
                                            _createElementVNode("td", {
                                                class: _normalizeClass(styles.td)
                                            }, _toDisplayString(__props.exam.amount) + _toDisplayString(_unref(t_common).translate('currency')) + _toDisplayString(_unref(t).translate('includeVAT')), 3)
                                        ])
                                    ])
                                ], 2)
                            ], 2)
                        ]),
                        _createElementVNode("div", null, [
                            _createElementVNode("strong", {
                                class: _normalizeClass(styles.titleDesc)
                            }, _toDisplayString(_unref(t).translate('applier')), 3),
                            _createElementVNode("p", {
                                class: _normalizeClass(styles.note),
                                innerHTML: _unref(t).translate('description')
                            }, null, 10, _hoisted_1),
                            _createElementVNode("div", {
                                class: _normalizeClass(styles.tableCover)
                            }, [
                                _createElementVNode("table", {
                                    class: _normalizeClass(styles.table)
                                }, [
                                    _createElementVNode("tbody", null, [
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", {
                                                class: _normalizeClass(styles.th)
                                            }, _toDisplayString(_unref(t).translate('name')), 3),
                                            _createElementVNode("td", {
                                                class: _normalizeClass(styles.inputTd)
                                            }, [
                                                _createVNode(_unref(BoxInput), {
                                                    "is-disabled": "",
                                                    modelValue: form.name,
                                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((form.name) = $event)),
                                                    error: form.$errors['name'],
                                                    "error-message": form.$errors['name']
                                                }, null, 8, ["modelValue", "error", "error-message"])
                                            ], 2)
                                        ]),
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", {
                                                class: _normalizeClass(styles.th)
                                            }, [
                                                _createTextVNode(_toDisplayString(_unref(t).translate('nameEngTitle')) + " ", 1),
                                                _createElementVNode("em", {
                                                    class: _normalizeClass(styles.required)
                                                }, "*", 2)
                                            ], 2),
                                            _createElementVNode("td", {
                                                class: _normalizeClass(_unref(clsx)(styles.inputTd, styles.inputTd2))
                                            }, [
                                                _createElementVNode("div", _hoisted_2, [
                                                    _createVNode(_unref(BoxInput), {
                                                        placeholder: _unref(t).translate('nameEngFamily'),
                                                        modelValue: form.nameEngFamily,
                                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((form.nameEngFamily) = $event)),
                                                        error: form.$errors['nameEngFamily'],
                                                        "error-message": form.$errors['nameEngFamily']
                                                    }, null, 8, ["placeholder", "modelValue", "error", "error-message"])
                                                ]),
                                                _createElementVNode("div", _hoisted_3, [
                                                    _createVNode(_unref(BoxInput), {
                                                        placeholder: _unref(t).translate('nameEngGiven'),
                                                        modelValue: form.nameEngGiven,
                                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((form.nameEngGiven) = $event)),
                                                        error: form.$errors['nameEngGiven'],
                                                        "error-message": form.$errors['nameEngGiven']
                                                    }, null, 8, ["placeholder", "modelValue", "error", "error-message"])
                                                ])
                                            ], 2)
                                        ]),
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", {
                                                class: _normalizeClass(styles.th)
                                            }, _toDisplayString(_unref(t).translate('phoneNumber')), 3),
                                            _createElementVNode("td", {
                                                class: _normalizeClass(styles.inputTd)
                                            }, [
                                                _createVNode(_unref(BoxInput), {
                                                    "is-disabled": "",
                                                    modelValue: form.phoneNumber,
                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((form.phoneNumber) = $event)),
                                                    error: form.$errors['phoneNumber'],
                                                    "error-message": form.$errors['phoneNumber']
                                                }, null, 8, ["modelValue", "error", "error-message"])
                                            ], 2)
                                        ]),
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", {
                                                class: _normalizeClass(styles.th)
                                            }, _toDisplayString(_unref(t).translate('email')), 3),
                                            _createElementVNode("td", {
                                                class: _normalizeClass(styles.inputTd)
                                            }, [
                                                _createVNode(_unref(BoxInput), {
                                                    "is-disabled": "",
                                                    modelValue: form.email,
                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((form.email) = $event)),
                                                    error: form.$errors['email'],
                                                    "error-message": form.$errors['email']
                                                }, null, 8, ["modelValue", "error", "error-message"])
                                            ], 2)
                                        ])
                                    ])
                                ], 2)
                            ], 2)
                        ]),
                        _createElementVNode("div", null, [
                            _createElementVNode("strong", {
                                class: _normalizeClass(styles.titleDesc)
                            }, _toDisplayString(_unref(t).translate('discount.code')), 3),
                            _createElementVNode("p", {
                                class: _normalizeClass(styles.note),
                                innerHTML: _unref(t).translate('discount.description')
                            }, null, 10, _hoisted_4),
                            _createElementVNode("div", {
                                class: _normalizeClass(styles.tableCover)
                            }, [
                                _createElementVNode("table", {
                                    class: _normalizeClass(styles.table)
                                }, [
                                    _createElementVNode("tbody", null, [
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", {
                                                class: _normalizeClass(styles.th)
                                            }, _toDisplayString(_unref(t).translate('discount.code')), 3),
                                            _createElementVNode("td", {
                                                class: _normalizeClass(styles.inputTd)
                                            }, [
                                                _createVNode(_unref(BoxInput), {
                                                    placeholder: _unref(t).translate('discount.placeholder'),
                                                    maxlength: 12,
                                                    modelValue: form.discountCode,
                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((form.discountCode) = $event))
                                                }, null, 8, ["placeholder", "modelValue"])
                                            ], 2)
                                        ])
                                    ])
                                ], 2)
                            ], 2)
                        ]),
                        _createElementVNode("div", {
                            class: _normalizeClass(styles.checkboxGroup)
                        }, [
                            _createElementVNode("div", {
                                class: _normalizeClass(styles.checkboxItem)
                            }, [
                                _createVNode(_unref(Checkbox), {
                                    id: "agree",
                                    label: _unref(t).translate('terms'),
                                    checked: form.terms.privateInfoCollectionTerm,
                                    "onUpdate:checked": _cache[6] || (_cache[6] = (checked) => (form.terms.privateInfoCollectionTerm = checked))
                                }, null, 8, ["label", "checked"]),
                                _createVNode(_unref(TextButton), {
                                    class: "!text-blue-700 hover:!text-blue-900",
                                    color: "blue",
                                    "desktop-size": "medium",
                                    "mobile-size": "medium",
                                    onClick: handleAgreementDetail
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(t_common).translate('button.view')), 1)
                                    ]),
                                    _: 1
                                })
                            ], 2),
                            (form.$errors['privateInfoCollectionTerm'])
                                ? (_openBlock(), _createElementBlock("p", {
                                    key: 0,
                                    class: _normalizeClass(styles.errorMsg),
                                    innerHTML: form.$errors['privateInfoCollectionTerm']
                                }, null, 10, _hoisted_5))
                                : _createCommentVNode("", true)
                        ], 2)
                    ], 2)
                ]),
                default: _withCtx(() => [
                    _createVNode(_unref(ModalFooter), null, {
                        default: _withCtx(() => [
                            _createVNode(_unref(OutlinedButton), {
                                class: "desktop:w-auto w-full !text-blue-700 hover:!text-blue-900",
                                onClick: _cache[7] || (_cache[7] = () => _unref(navigateTo)(`${_unref(getCloudIdOrigin)()}/members/information`)),
                                color: "blue",
                                "desktop-size": "large",
                                "mobile-size": "medium"
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t_common).translate('button.memberUpdate')), 1)
                                ]),
                                _: 1
                            }),
                            _createVNode(_unref(FilledButton), {
                                class: "desktop:w-auto w-full",
                                color: "blue",
                                "desktop-size": "large",
                                "mobile-size": "medium",
                                onClick: _cache[8] || (_cache[8] = (e) => onPayClick(e))
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t_common).translate('button.pay')), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }, 8, ["modelValue", "title"]));
        };
    }
});
